module.exports = __webpack_public_path__ + "img/9791196552503.92b31dfb.jpg";